<div class="sso-wrapper">
  <div class="sso-card text-center">
    <div class="sso-logo mb-4">
      <img src="assets/images/logo.png" alt="Treasure Hill" />
    </div>

    @if (error(); as error) {
      <i class="bi sso-icon text-white {{ error.icon }}"></i>
      <h2 class="mb-2 fw-400 text-white fs-20">{{ error.title }}</h2>
      <p class="mb-4 fw-400 text-gray-300 fs-14">{{ error.detail }}</p>
      <div class="d-flex flex-column align-items-center gap-2">
        @if (error.canRetry) {
          <button type="button" class="btn btn-primary sso-action" (click)="retry()">Try again</button>
          <a routerLink="/welcome" class="text-gray-300 fs-14 text-decoration-none">Back to the portal</a>
        } @else {
          <a routerLink="/welcome" class="btn btn-primary sso-action">Back to the portal</a>
        }
      </div>
    } @else {
      <div class="spinner-border text-light mb-3" role="status" aria-label="Loading"></div>
      <h2 class="mb-2 fw-400 text-white fs-20">Opening the CRM</h2>
      <p class="mb-0 fw-400 text-gray-300 fs-14">Signing you in…</p>
    }
  </div>
</div>
